<template>
    <div>
        <div class="row mb-4">
            <div class="col-md-3">
                <v-select
                    :options="statuses"
                    placeholder="All Job Statuses"
                    v-model="filters.status"
                />
            </div>
            <div class="col-md-3">
                <v-select
                    :options="wipStatuses"
                    placeholder="WIP Filter"
                    v-model="filters.hasWip"
                />
            </div>
            <div class="col-md-3" v-if="showOwnedBy">
                <v-select
                    :options="ownerTypes"
                    placeholder="Owned By"
                    v-model="filters.ownedBy"
                />
            </div>
        </div>
        <table ref="table" class="table table-bordered table-striped table-vcenter dataTable">
            <thead>
            <tr>
                <th>#</th>
                <th>Job Name</th>
                <th>Vehicle</th>
                <th>Status</th>
                <th v-if="showOwnedBy">Owned By</th>
                <th>Assigned Users</th>
                <th>Updated At</th>
                <th>Has WIP</th>
                <th></th>
            </tr>
            </thead>
            <tbody></tbody>
        </table>
    </div>
</template>

<script>
import { Eventbus } from '@/components/eventbus';
import VSelect from 'vue-select';

let dataTableColumns = [
    {
        data: 'number',
    },
    {
        data: 'description',
    },
    {
        data: 'vehicle.description',
        searchable: false,
        orderable: false,
    },
    {
        data: 'status',
    },
    {
        data: 'staff_names',
    },
    {
        data: 'updated_at',
    },
    {
        data: 'has_wip',
        render: (data) => (data)
            ? '<i class="fa fa-times-circle text-danger"></i>'
            : '<i class="fa fa-check-circle text-success"></i>',
        searchable: false,
        orderable: false,
    },
    {
        data: 'actions',
    },
    {
        data: 'vehicle.year',
        visible: false,
    },
    {
        data: 'vehicle.make',
        visible: false,
    },
    {
        data: 'vehicle.model',
        visible: false,
    },
    {
        data: 'vehicle.type',
        visible: false,
    },
];
export default {
    components: {
        VSelect,
    },

    props: {
        ajaxUrl: String,
        statuses: Array,
        wipStatuses: Array,
        showOwnedBy: false,
        ownerTypes: Array,
    },

    data () {
        return {
            filters: {
                status: null,
                hasWip: null,
                ownedBy: null,
            },
        }
    },

    mounted () {

        if (this.showOwnedBy) {
            dataTableColumns.splice(4,0,{
                data: "vehicle.owned_by"
            });
        }

        let table = window.jQuery(this.$refs.table).on('preXhr.dt', (e, settings, data) => {
            data.filters = this.filters;
        }).DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[5, 'desc']],
            columns: dataTableColumns
        });

        let adjust = () => {
            this.$refs.table.removeAttribute('style');
            table.columns.adjust();
        };

        if (document.getElementById('staff-jobs-tab')) {
            document.getElementById('staff-jobs-tab').addEventListener('shown.bs.tab', adjust);
        }

        table.on('draw', adjust);

        Eventbus.on('jobs-table-refresh', () => {
            table.ajax.reload(null, false);
        });

        // watch api to use table without saving it to data
        this.$watch(
            'filters',
            () => table.ajax.reload(null, false),
            {
                deep: true
            }
        );


    }
}
</script>
